import React, {useEffect, useState} from "react"
import {Button, Form, Input, message, Modal, Popconfirm, Result, Select, Space, Tag, Tooltip} from "antd"
import {bindShop, fetchRelationGroupon, fetchUnbind} from "../../../../../api/groupon"
import {useGroupBuyingContext} from "../../../store/useGroupBuyingContext"
import {useFetch} from "../../../../../util/useFetch"
import PlatformCode from "../../../../ClubPlatform/common/ClubPlatformContanst"
import {fetchRelationStore} from "../../../../../api/clubPlatform"

const GroupBuyingEditRelation = ({groupon, platformName, platformCode}) => {

    const {grouponListState} = useGroupBuyingContext()

    const [isShow, setIsShow] = useState(false)
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)
    const [isUnbindLoading, setIsUnbindLoading] = useState(false)
    const [isShowUnbind, setIsShowUnbind] = useState(groupon.platforms.find(item => item.platform.id === platformCode) !== undefined)
    const [isSelectEnable, setIsSelectEnable] = useState(true)
    const [isInputEnable, setIsInputEnable] = useState(true)

    const [form] = Form.useForm()

    const relationGrouponListState = useFetch(() => fetchRelationGroupon(platformCode))

    const dealId = Form.useWatch("dealId", form)

    const platformDealId = Form.useWatch("platformDealId", form)

    useEffect(() => {
        if (platformCode === PlatformCode.DouYin) {
            if (dealId) {
                setIsInputEnable(false)
            } else {
                setIsInputEnable(true)
            }
            if (platformDealId) {
                setIsSelectEnable(false)
            } else {
                setIsSelectEnable(true)
            }
        }
    }, [dealId, platformDealId])


    const handleSelectOption = (data) => {
        if (!data) {
            return []
        }
        return data.map(item => {
            return {
                value: item.platformDealId,
                label: (<div style={{display: "flex"}}>
                    <div>
                        <Tag color={"gold"}>{"金额：" + (item.amount / 100).toFixed(2)}</Tag>
                    </div>
                    <Tooltip title={item.name}>
                        <div style={{
                            marginRight: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: 300
                        }}>{item.name}</div>
                    </Tooltip>
                </div>)
            }
        })
    }

    const formInitialValues = () => {
        form.resetFields()
        const platform = groupon.platforms.find(item => item.platform.id === platformCode)
        if (platform) {
            const platformDeal = relationGrouponListState.data.find(item => item.platformDealId === platform.deal.platformDealId)
            console.log("platform", platform)
            console.log("platformDeal", platformDeal)
            if (platformDeal) {
                form.setFieldsValue({dealId: platform.deal.platformDealId})
            } else {
                form.setFieldsValue({platformDealId: platform.deal.platformDealId})
            }
        }

    }


    const handleClick = async () => {
        setIsShow(true)
        formInitialValues()
    }

    const handleFinish = async () => {
        setIsConfirmLoading(true)
        try {
            const dealId = form.getFieldValue("dealId")
            const platformDealId = form.getFieldValue("platformDealId")

            if (!dealId && !platformDealId) {
                throw new Error("请选择或输入绑定商品")
            }

            if (dealId) {
                //如果dealId和平台的dealId一样，不需要编辑
                const platform = groupon.platforms.find(item => item.platform.id === platformCode)
                if (platform && platform.deal.platformDealId === dealId) {
                    setIsShow(false)
                    message.success("编辑成功")
                    return
                }
                const {status, detail} = await bindShop({
                    grouponId: groupon.groupon.id,
                    platformId: platformCode,
                    deal: relationGrouponListState.data.find(item => item.platformDealId === dealId)
                })
                if (status !== 1) {
                    throw new Error(detail)
                }
                message.success("编辑成功")
            } else {
                const {status: shopStatus, data: shopData, detail: shoDetail} = await fetchRelationStore()
                if (shopStatus !== 1) {
                    throw new Error(shoDetail)
                }
                const shop = shopData.find(item => item.platform.id === PlatformCode.DouYin).value.shop

                if (shop == null) {
                    throw new Error("抖音店铺未绑定")
                }

                const {status, detail} = await bindShop({
                    grouponId: groupon.groupon.id,
                    platformId: platformCode,
                    deal: {
                        shopId: shop.id,
                        platformDealId: platformDealId,
                        name: platformDealId,
                        amount: 0
                    }
                })
                if (status !== 1) {
                    throw new Error(detail)
                }
                message.success("编辑成功")

            }
        } catch (e) {
            message.error(`编辑失败：${e.message}`)
        } finally {
            setIsShow(false)
            setIsConfirmLoading(false)
            await grouponListState.reFetch()
        }

    }

    const handleUnBind = async () => {
        try {
            setIsUnbindLoading(true)
            const {status, data, detail} = await fetchUnbind(groupon.groupon.id, platformCode)
            if (status !== 1) {
                throw new Error(detail)
            }
            message.success("解绑成功")
            setIsShow(false)
        } catch (e) {
            message.error(e.message)
        } finally {
            setIsUnbindLoading(false)
            await grouponListState.reFetch()
        }

    }

    return (
        <div>
            <span onClick={handleClick}>编辑{platformName}团购</span>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                width={700}

                footer={
                    <Space direction={"horizontal"}>
                        <Button onClick={() => setIsShow(false)}>取消</Button>
                        {isShowUnbind &&
                            <Popconfirm title="确定解绑？" onConfirm={handleUnBind} okText={"确定"}
                                        cancelText={"取消"}><Button
                                type={"primary"} danger loading={isUnbindLoading}>解绑</Button></Popconfirm>}
                        <Button onClick={form.submit} type={"primary"} loading={isConfirmLoading}>确定</Button>
                    </Space>
                }
            >
                {relationGrouponListState.error
                    ? <Result status={"error"} title={"获取关联团购列表失败"}
                              subTitle={relationGrouponListState.error.message}/> :

                    <Form
                        style={{padding: "20px"}}
                        form={form}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 18}}
                        onFinish={handleFinish}
                    >
                        <Form.Item
                            label={`${platformName}关联`}
                            name={"dealId"}
                            valuePropName={"value"}
                        >
                            <Select
                                options={handleSelectOption(relationGrouponListState.data)}
                                style={{width: 350}}
                                placeholder={`请选择${platformName}团购`}
                                disabled={!isSelectEnable}
                                allowClear={true}
                            />
                        </Form.Item>
                        {platformCode === PlatformCode.DouYin && <Form.Item
                            label={"手动绑定商品ID"}
                            name={"platformDealId"}
                            valuePropName={"value"}
                        >
                            <Input disabled={!isInputEnable} style={{width: 350}}
                                   placeholder={"请手动输入绑定商品ID"}/>
                        </Form.Item>}
                    </Form>
                }
            </Modal>
        </div>
    )
}

export default GroupBuyingEditRelation


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingEdit/component/GroupBuyingEditRelation.js